module.exports = __webpack_public_path__ + "6cdd2c82670e8a29658f11a6bffe5eb9.MP3";